import { createAction, props } from '@ngrx/store';
import { Order, PagedOrders, CalculatedOrderRoute, VehicleTypes, OrderFiltersState } from '../../models/orders.models';

export const updateOrder = createAction(
    '[Order] Update Order',
    props<{ order: Order }>()
);

export const loadOrders = createAction(
    '[Order] Load Orders',
);

export const loadOrdersSuccess = createAction(
    '[Order] Load Orders Success',
    props<{ orders: PagedOrders }>()
);

export const loadOrdersFailure = createAction(
    '[Order] Load Orders Failure',
    props<{ error: any }>()
);

export const loadManualOrders = createAction(
    '[Order] Load Manual Orders',
    props<{ page: number, limit: number, query?: string, from?: Date, to?: Date }>()
  );
  
  export const loadManualOrdersSuccess = createAction(
    '[Order] Load Manual Orders Success',
    props<{ orders: PagedOrders }>()
  );
  
  export const loadManualOrdersFailure = createAction(
    '[Order] Load Manual Orders Failure',
    props<{ error: any }>()
  );
  
  export const loadManualOrdersByRiderId = createAction(
    '[Order] Load Manual Orders By Rider Id',
    props<{ rider_id: number, page: number, limit: number, from?: Date, to?: Date }>()
  );

  export const loadManualOrdersByRiderIdSuccess = createAction(
    '[Order] Load Orders By Rider Id Success',
    props<{ orders: PagedOrders }>()
);

export const loadManualOrdersByRiderIdFailure = createAction(
    '[Order] Load Orders By Rider Id Failure',
    props<{ error: any }>()
);

export const loadOrdersByRiderId = createAction(
    '[Order] Load Orders By Rider Id',
    props<{ rider_id: number,  page: number, limit: number, from?: Date, to?: Date }>()
);

export const loadOrdersByRiderIdSuccess = createAction(
    '[Order] Load Orders By Rider Id Success',
    props<{ orders: PagedOrders }>()
);

export const loadOrdersByRiderIdFailure = createAction(
    '[Order] Load Orders By Rider Id Failure',
    props<{ error: any }>()
);

export const loadOrderById = createAction(
    '[Order] Load Order By Id',
    props<{ id: number }>()
);

export const loadOrderByIdSuccess = createAction(
    '[Order] Load Order By Id Success',
    props<{ orders: PagedOrders, id: number }>()
);

export const loadOrderByIdFailure = createAction(
    '[Order] Load Order By Id Failure',
    props<{ error: any }>()
);

export const loadPendingOrders = createAction(
    '[Order] Load Pending Orders',
    props<{ page: number, limit: number, query?: string }>()
);

export const loadPendingOrdersSuccess = createAction(
    '[Order] Load Pending Orders Success',
    props<{ orders: PagedOrders }>()
);

export const loadPendingOrdersFailure = createAction(
    '[Order] Load Pending Orders Failure',
    props<{ error: any }>()
);

export const loadInProgressOrders = createAction(
    '[Order] Load In Progress Orders',
    props<{ page: number, limit: number, query?: string }>()
);

export const loadInProgressOrdersSuccess = createAction(
    '[Order] Load In Progress Orders Success',
    props<{ orders: PagedOrders }>()
);

export const loadInProgressOrdersFailure = createAction(
    '[Order] Load In Progress Orders Failure',
    props<{ error: any }>()
);

export const loadFinishedOrders = createAction(
    '[Order] Load Finished Orders',
    props<{ page: number, limit: number, query?: string }>()
);

export const loadFinishedOrdersSuccess = createAction(
    '[Order] Load Finished Orders Success',
    props<{ orders: PagedOrders }>()
);

export const loadFinishedOrdersFailure = createAction(
    '[Order] Load Finished Orders Failure',
    props<{ error: any }>()
);

export const loadFinishedOrdersWithCashToCollect = createAction(
    '[Order] Load Finished Orders With Cash To Collect',
    props<{ page: number, limit: number, query?: string }>()
);

export const loadFinishedOrdersWithCashToCollectSuccess = createAction(
    '[Order] Load Finished Orders With Cash To Collect Success',
    props<{ orders: PagedOrders }>()
);

export const loadFinishedOrdersWithCashToCollectFailure = createAction(
    '[Order] Load Finished Orders With Cash To Collect Failure',
    props<{ error: any }>()
);

export const createOrder = createAction(
    '[Order] Create Order',
);

export const createOrderSuccess = createAction(
    '[Order] Create Order Success',
    props<{ order: Order }>()
);

export const createOrderFailure = createAction(
    '[Order] Create Order Failure',
    props<{ error: any }>()
);

export const createManualOrder = createAction(
    '[Order] Create Manual Order',
);

export const createManualOrderSuccess = createAction(
    '[Order] Create Manual Order Success',
    props<{ order: Order }>()
);

export const createManualOrderFailure = createAction(
    '[Order] Create Manual Order Failure',
    props<{ error: any }>()
);

export const editOrder = createAction(
    '[Order] Edit Order',
);

export const editOrderSuccess = createAction(
    '[Order] Edit Order Success',
    props<{ order: Order }>()
);

export const editOrderFailure = createAction(
    '[Order] Edit Order Failure',
    props<{ error: string }>()
);

export const assignOrderToRider = createAction(
    '[Order] Assign Order To Rider',
    props<{ order_id: number, rider_id: number }>()
);

export const assignOrderToRiderSuccess = createAction(
    '[Order] Assign Order To Rider Success',
    props<{ order: Order }>()
);

export const assignOrderToRiderFailure = createAction(
    '[Order] Assign Order To Rider Failure',
    props<{ error: any }>()
);

export const calculateOrderRoute = createAction(
    '[Order] Calculate Order Route',
);

export const calculateOrderRouteSuccess = createAction(
    '[Order] Calculate Order Route Success',
    props<{ calculatedOrderRoute: CalculatedOrderRoute }>()
);

export const calculateOrderRouteFailure = createAction(
    '[Order] Calculate Order Route Failure',
    props<{ error: any }>()
);

export const currentOrder = createAction(
    '[Order] Current Order',
    props<{ order: Order }>()
);

export const currentOrderId = createAction(
    '[Order] Current Order Id',
    props<{ id: number }>()
);

export const cancelOrder = createAction(
    '[Order] Cancel Order',
    props<{ order_id: number }>()
);

export const cancelOrderSuccess = createAction(
    '[Order] Cancel Order Success',
    props<{ order: Order }>()
);

export const cancelOrderFailure = createAction(
    '[Order] Cancel Order Failure',
    props<{ error: any }>()
);

export const reassignOrder = createAction(
    '[Orders] Reassign Order',
    props<{ order_id: number, rider_id: number }>()
  );

export const reassignOrderSuccess = createAction(
    '[Orders] Reassign Order Success',
    props<{ order_id: number, payload: Order }>()
  );

export const reassignOrderFailure = createAction(
    '[Orders] Reassign Order Failure',
    props<{ error: any }>()
  );

  export const selectOrder = createAction(
    '[Order] Select Order',
    props<{ order: Order }>()
  );
  
  export const clearSelectedOrder = createAction(
    '[Order] Clear Selected Order'
  );

  export const confirmCashDelivered = createAction(
    '[Order] Confirm Cash Delivered',
    props<{ order_id: number, confirmed: string }>()
  );

  export const confirmCashDeliveredSuccess = createAction(
    '[Order] Confirm Cash Delivered Success',
    props<{ order: Order }>()
  );

    export const confirmCashDeliveredFailure = createAction(
        '[Order] Confirm Cash Delivered Failure',
        props<{ error: any }>()
    );

    export const loadVehicleTypes = createAction(
        '[Order] Load Vehicle Types'
    );

    export const loadVehicleTypesSuccess = createAction(
        '[Order] Load Vehicle Types Success',
        props<{ vehicleTypes: VehicleTypes[] }>()
    );

    export const loadVehicleTypesFailure = createAction(
        '[Order] Load Vehicle Types Failure',
        props<{ error: any }>()
    );

    export const updateFilters = createAction(
      '[Manual Services] Update Filters',
      props<{ filters: Partial<OrderFiltersState> }>() // Filters to be updated
    );

    export const clearFilters = createAction(
      '[Manual Services] Clear Filters'
    );

    export const applyFilters = createAction(
      '[Manual Services] Apply Filters',  
        
    );


